import React from 'react';
import { Typography, WithInfoIcon, Skeleton } from 'seagull';
import { utils } from "../../../../utils";
import GraphWidgetTopCard from "../../GraphWidget/GraphWidgetTopCard";
import styles from "./MonthlyEarningsTopCard.module.scss";
export default function MonthlyEarningsTopCard(props) {
  const {
    title,
    amount,
    info,
    loading,
    testid,
    success
  } = props;
  return /*#__PURE__*/React.createElement(GraphWidgetTopCard, {
    className: styles.root
  }, amount === undefined || loading ? /*#__PURE__*/React.createElement("div", {
    className: styles.loading,
    "data-testid": testid && "".concat(testid, "-loading")
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 12,
    width: "50%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 20,
    width: "25%"
  })) : /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    "data-testid": testid
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: info
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph1",
    skin: success ? 'success' : 'secondary'
  }, title)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    weight: "normal",
    "data-testid": testid && "".concat(testid, "-amount")
  }, utils.formatDollarAmount(amount))));
}